// ... our configuration variables (potentially from process.env.REACT_APP_*)

import * as gitVersion from "gitVersion";

declare var APP_ENV: string;
declare var API_BASE_URL: string;
declare var API_CARD_BASE_URL: string;
declare var API_MESSAGING_BASE_URL: string;
declare var STORE_BASE_URL: string;
declare var LOGIN_BASE_URL: string;
declare var IMAGE_BASE_URL: string;
declare var API_ADVISORSERVICES_BASE_URL: string;
declare var APP_BASE_URL: string;
declare var API_ACCOUNT_BASE_URL: string;
declare var LUX_BASE_URL: string;
declare var LUX_API_KEY: string;
declare var API_GEORGE_BUSINESS_BASE_URL: string;
declare var API_ECOS_BASE_URL: string;
export const apiBaseUrl = API_BASE_URL;

const LOCAL_IP = process.env.REACT_APP_MY_IP; // || "192.168.1.15";
const PROXY_PORT = "1337";
const HTTPS = "https://";
const HTTP = "http://";

const prefix = process.env.REACT_APP_USE_PROXY
    ? process.env.REACT_APP_USE_PROXY === "local"
        ? `http://localhost:${PROXY_PORT}/${HTTPS}`
        : `http://${LOCAL_IP}:${PROXY_PORT}/${HTTPS}`
    : HTTPS;

export const IS_MASTER = gitVersion.GIT_BRANCH === "master";

const IS_FAT = APP_ENV !== "prod";

export type SupportedLocales = "en" | "de";

export const config = {
    // DEBUG true has slightly different behaviour, e.g. not removing access token from URL for easier testing
    DEBUG: false,
    // Use this to force DEBUG_LOG on master. On all other branches logging is enabled by default
    DEBUG_LOG: false,

    // Various testing flags to allow UI development without failing API calls
    TEST_FLICKER: !IS_MASTER && false,
    TEST_SIDENTITY_UI: !IS_MASTER && false,

    // General features
    CONSUMER_LOAN_ENABLED: true,
    APPOINTMENT_ENABLED: true,
    DEFERRAL_SERVICE_ENABLED: true,
    TRACKING_ENABLED: true,
    APP_STORE_REDIRECT_ENABLED: true,
    // This feature is deprecated and will remain in the code base as backup according to customer request
    APP_STORE_REDIRECT_DEPRECATED_ENABLED: false,
    // This feature is used to redirect to the campaign page for Testing purposes, Will be removed after testing
    APP_STORE_REDIRECT_CAMPAIGN_ENABLED: true,
    LOGIN_MANAGEMENT: true,
    ICH_APP: true,
    TEAMCARD_LINKAGE: true,
    JUNIOR: true,
    APP_BUSINESS_STORE_REDIRECT_ENABLED: true,

    // Card features
    PIN_RESET_ENABLED: true,
    CHANGE_REPAYMENT_ENABLED: true,
    QUICK_DRAWDOWN_ENABLED: true,
    GEO_CONTROL_ENABLED: true,
    REISSUE_CARD_ENABLED: true,
    REISSUE_CARD_UPGRADE_ENABLED: true,
    ACTIVATE_CARD_ENABLED: true,
    LINK_ACCOUNT: true,
    SHOW_CARD_DATA: true,
    SIDENTITY_ENABLED: true,
    // SIDENTITY_FORCE_ONBOARDING() {

    //     // ACHTUNG: immer auch checken ob die uhrzeit selbst mit eingerechnet wird!
    //     return moment() > moment("2020-12-31");
    // },
    SIDENTITY_SETTINGS_ENABLED: true,
    GID_SETTINGS_ENABLED: true,
    GID_SETTINGS_MAX_DAILY_LIMIT: 999999999,
    TPP_ENABLED: true,
    GIG_ENABLED: true,
    ACCIDENT_INSURANCE_ENABLED: true,
    PENSION_INSURANCE_ENABLED: true,
    LIFE_INSURANCE_ENABLED: true,
    PENSION_FUNDS_ENABLED: true,
    CAR_LEASING_ENABLED: true,
    FIT_ENABLED: true,
    LOYALTY_ENABLED: true,
    OPTIO_PAY_ENABLED: true,
    STORE_PLUGINS_ENABLED: true,
    USERMANAGEMENT_ENABLED: true,
    SURVEY_ENABLED: true,
    GOOGLE_PAY_ENABLED: true,
    POCKETS_ENABLED: true,
    BSP_OPTIONS_ENABLED: true,
    BSP_OPTIONS_PAYOUT_ENABLED: true,
    ASSET_CALCULATION_ENABLED: true,
    TRADING_PREFERENCES_ENABLED: true,
    SAVINGS_OPTIONS_ENABLED: true,
    HOUSEHOLD_INSURANCE_ENABLED: true,
    //===============================================
    // IMPORTANT: always set to false to disable the handover url test in Production
    //===============================================
    //===============================================
    // UPDATE 02.12.25 : set to true to enable the handover url test in FAT
    //===============================================
    HANDOVER_URL_TEST_ENABLED: IS_FAT ? true : false,

    // Shop features
    SHOP_ENABLED: true,
    SHOP_CREDIT_CARD_ENABLED: true,
    SHOP_CREDIT_CARD_BUSINESS_ENABLED: true,
    BANK_CARD_ENABLED: true,
    SAVINGS_ENABLED: false,
    STORE_ENABLED: true,
    CREDIT_CARD_UPGRADE_ENABLED: true,

    // Locale settings
    DEFAULT_LANGUAGE: "de" as SupportedLocales,
    CURRENCY_LOCALE: "de" as SupportedLocales,
    CURRENCY_DECIMAL_SEPARATOR: ",",
    CURRENCY_THOUSANDS_SEPARATOR: ".",

    // Base URLs
    network: {
        get environment() {
            return APP_ENV;

            // if (API_BASE_URL.indexOf("fat1") !== -1) {
            //     return "fat1";
            // } else if (API_BASE_URL.indexOf("fat2") !== -1) {
            //     return "fat2";
            // } else if (API_BASE_URL.indexOf("fat3") !== -1) {
            //     return "fat3";
            // } else {
            //     return "prod";
            // }
        },

        environmentIsFat: IS_FAT,
        imageBaseUrl: IMAGE_BASE_URL,
        baseUrl: prefix + API_BASE_URL,
        cardBaseUrl: prefix + API_CARD_BASE_URL,
        accountBaseUrl: prefix + API_ACCOUNT_BASE_URL,
        messagingBaseUrl: prefix + API_MESSAGING_BASE_URL,
        genericBaseUrl: prefix,
        storeBaseUrl: HTTPS + STORE_BASE_URL,
        loginBaseUrl: prefix + LOGIN_BASE_URL,
        loginBaseUrlHttps: HTTPS + LOGIN_BASE_URL,
        adivsorServicesBaseUrl: prefix + API_ADVISORSERVICES_BASE_URL,
        appBaseUrl: APP_BASE_URL,
        luxBaseUrl: prefix + LUX_BASE_URL,
        luxApiKey: LUX_API_KEY,
        georgeBusinessBaseUrl: prefix + API_GEORGE_BUSINESS_BASE_URL,
        ecosBaseUrl: prefix + API_ECOS_BASE_URL,
    }
};

if (!IS_MASTER) {
    console.log("### local ip " + process.env.REACT_APP_MY_IP);
    console.log("### baseUrl " + config.network.baseUrl);
    console.log("### cardUrl " + config.network.cardBaseUrl);
}



// WEBPACK FOOTER //
// ./src/config.ts